module.exports = __webpack_public_path__ + "img/Calming Presence.df98a51c.png";